import * as React from "react";
import { Button } from "@progress/kendo-react-buttons";
import styles from "../Settings.module.scss";
import DepartmentList from "./DepartmentsList";
import EditDepartment from "./EditDepartments";
import { toast } from "react-toastify";
import { addDepartments } from "services/departmentService";

const Department = (props) => {
  const [addnewform, setaddnewform] = React.useState(false);
  const [isSubmitting, setIsSubmitting] = React.useState(false);

  const closeform = () => {
    setaddnewform(false);
  };

  const handleSubmit = async (e) => {
    setIsSubmitting(true);
    try {
      const result = await addDepartments({
        ...e,
        active: true,
      });

      if (result.success) {
        toast.success("Department Added");
      }
    } catch (error) {
      toast.error("Error Occurred");
    } finally {
      setIsSubmitting(false);
      setaddnewform(false);
    }
  };

  return (
    <React.Fragment>
      <>
        <div className="row">
          <div className="col-lg-10 col-md-8"></div>

          <Button
            className={`common-btn col-lg-1 col-md-4 p-2 mt-5 ${
              styles[`button`]
            }`}
            onClick={() => {
              setaddnewform(true);
            }}
          >
            Add <br></br>
            Department
          </Button>
        </div>

        <div className={`row mx-auto mt-3 col-12 col-xl-9 col-xxl-6`}>
          <DepartmentList />
        </div>
      </>
      {addnewform && (
        <EditDepartment
          cancelEdit={closeform}
          onSubmit={handleSubmit}
          type="addNew"
          isSubmitting={isSubmitting}
        />
      )}
    </React.Fragment>
  );
};

export default Department;
